import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class MsalUserService {
    private accessToken: any;
    constructor(private authService: MsalService, private httpClient: HttpClient) {

    }

    public GetAccessToken(): Observable<any> {
        if (sessionStorage.getItem('msal.idtoken') !== undefined && sessionStorage.getItem('msal.idtoken') != null) {
            this.accessToken = sessionStorage.getItem('msal.idtoken');
        }
        return this.accessToken;
    }

    public authCallback(errorDesc, token, error, tokenType) {
        if (token) {

        } else {
            console.log(error + ':' + errorDesc);
        }
    }

    public getCurrentUserInfo() {
        this.httpClient.get("https://graph.microsoft.com/v1.0/me").subscribe((response) => {
            console.log(response)
        });
    }

    public logout() {

    }
}